/** The four "What changes." cells on the Why page. */
export interface Payoff {
  n: string
  lab: string
  title: string
  body: string
}

export const PAYOFF: ReadonlyArray<Payoff> = [
  {
    n: '01',
    lab: 'First pass',
    title: 'Cost.',
    body: 'Musts ride first, so drafts clear review much faster. The revision loop collapses — and with it, the token bill for undoing bad passes.',
  },
  {
    n: '02',
    lab: 'Rules that hold',
    title: 'Fidelity.',
    body: "Attention decays; seating doesn't. Binding rules stop competing with trivia for the model's budget. What must hold, holds.",
  },
  {
    n: '03',
    lab: 'Answers on the record',
    title: 'Proof.',
    body: 'Every answer ships with a signed receipt — which instructions, which versions, on what trigger. When someone asks how you know, you show them.',
  },
  {
    n: '04',
    lab: 'Yours',
    title: 'Ownership.',
    body: "The library compounds and travels. Switch models; the judgment stays. It's the only part of your AI stack that appreciates.",
  },
]
